import { CartPromotion } from "@omni/types/api/cart/bff/shared/cartPromotion.model";
import { PromoPackType } from "@omni/types/api/product/bff/shared/enums/promoPackType.enum";

type Props = {
    promotions?: Array<CartPromotion>;
};

const VISIBLE_PROMOTION_TYPES = [
    PromoPackType.Zbon,
    PromoPackType.DocumentKorting
];

const PromotionItems = ({ promotions }: Props) => {
    const filteredPromotion = (promotions || []).filter(
        (p) =>
            p.commercialText !== null &&
            VISIBLE_PROMOTION_TYPES.includes(p.promotionType)
    );

    return (
        <>
            {filteredPromotion.length > 0 && (
                <div className="font-weight-bold text-success mb-3">
                    {filteredPromotion.map((promotion, index) => (
                        <div key={index}>{promotion.commercialText}</div>
                    ))}
                </div>
            )}
        </>
    );
};

export { PromotionItems };
